import styled, { css } from 'styled-components'

export const ModalWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1000;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.45);
`

export const Modal = styled.div<{ width?: string; isScroll?: boolean }>`
	max-width: 95vw;
	max-height: 80vh;
	position: relative;
	background-color: white;
	padding: 24px;
	box-shadow: 0 10px 20px rgb(0 0 0 / 25%);
	border-radius: 8px;
	${({ width }) =>
		width &&
		css`
			width: ${width};
		`}
	${({ isScroll }) =>
		isScroll &&
		css`
			overflow-y: auto;
			height: 100%;
		`}
`

export const IconClose = styled.div`
	position: fixed;
	cursor: pointer;
	width: 20px;
	height: 20px;
	z-index: 1000;
	svg {
		width: 20px;
		height: 20px;
		fill: black;
		&:hover {
			fill: black;
		}
	}
`

export const Header = styled.div`
	position: absolute;
	top: 10px;
	right: 30px;
`
